import React, { useState, useContext } from "react"; // Import useContext
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { AuthContext } from "../context/AuthContext";
import { LanguageContext } from "../context/LanguageContext"; // Import LanguageContext

function Login() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const { setIsLoggedIn } = useContext(AuthContext);
  const { language } = useContext(LanguageContext); // Consume LanguageContext

  // --- Translatable Content Definitions ---
  const enContent = {
    loginTitle: "Login",
    emailLabel: "Email",
    passwordLabel: "Password",
    signInButton: "Sign In",
    loginSuccess: "✅ Login successful!",
    loginFailed: "Login failed.",
    somethingWentWrong: "Something went wrong.",
    noAccountPrompt: "Don't have an account?",
    signUpLink: "Sign Up",
    signUpNow: " now!",
  };

  const urContent = {
    loginTitle: "لاگ ان", // Login
    emailLabel: "ای میل", // Email
    passwordLabel: "پاس ورڈ", // Password
    signInButton: "سائن ان کریں", // Sign In
    loginSuccess: "✅ لاگ ان کامیاب!", // Login successful!
    loginFailed: "لاگ ان ناکام رہا۔", // Login failed.
    somethingWentWrong: "کچھ غلط ہو گیا۔", // Something went wrong.
    noAccountPrompt: "اکاؤنٹ نہیں ہے؟", // Don't have an account?
    signUpLink: "سائن اپ کریں", // Sign Up
    signUpNow: " ابھی!", // now!
  };

  const content = language === "en" ? enContent : urContent;
  // --- End Translatable Content Definitions ---

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || content.loginFailed); // Use translated message
        return;
      }

      // Save token in localStorage (or context)
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setMessage(content.loginSuccess); // Use translated message
      setIsLoggedIn(true);

      // Optionally redirect
      setTimeout(() => {
        window.location.href = "/"; // Change this route to wherever you want
      }, 1000);
    } catch (err) {
      setError(err.message || content.somethingWentWrong); // Use translated message
    }
  };

  return (
    <Box
      className="login-container"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h3" gutterBottom color="black" textAlign="center">
          {content.loginTitle}
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            backgroundColor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <TextField
            label={content.emailLabel}
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label={content.passwordLabel} 
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            fullWidth
            required
          />
          <Button variant="contained" type="submit">
            {content.signInButton} 
          </Button>
        </Box>

        {message && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {message}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        <Typography variant="body1" sx={{ mt: 3 }} textAlign="center">
          {content.noAccountPrompt}{" "}
          <a href="/signup">
            {content.signUpLink}
          </a>
          {content.signUpNow}
        </Typography>
      </Container>
    </Box>
  );
}

export default Login;